/* «Combina tus colores» — página /pages/combina-tus-colores (Saira Muebles, 4-oct-2026).
   Diseño v2 aprobado por Daniel. Elige tono -> telas REALES disponibles -> 3 propuestas, con la sala
   dibujada en CSS (sin 3D, sin imágenes pesadas). Los datos salen de la carta del CRM:
     GET <url_carta>  ->  { grupos:[...], telas:[...], paletas:[...] }
   La URL vive en UN solo lugar: el ajuste «URL de la carta» de la sección (templates/page.combina-tus-colores.json).
   Vacío = JSON de prueba del tema (assets/saira-combina-carta-prueba.json).
   Pruebas en el navegador: ?cc=error  ·  ?cc=lento  ·  ?cc=sin (el tono elegido sin telas). */
(function () {
  'use strict';
  var root = document.querySelector('[data-scc]');
  if (!root || root.__scc) return;
  root.__scc = 1;

  var CRM = 'https://sara.mueblessaira.com';
  var WA = '573232212542';
  var E = 'cubic-bezier(0.22, 1, 0.36, 1)';
  var MQ_RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function quieto() { return !!MQ_RM.matches; }

  var MADERAS = {
    natural: { nombre: 'Natural', hex: '#C59A6A', tipo: 'madera' },
    caramelo: { nombre: 'Caramelo', hex: '#9A6235', tipo: 'madera' },
    chapillado: { nombre: 'Chapillado', hex: '#CDA676', tipo: 'madera' },
    blanco: { nombre: 'Blanco', hex: '#EDEAE4', tipo: 'pintura' },
    negro: { nombre: 'Negro', hex: '#222222', tipo: 'pintura' },
    marmol: { nombre: 'Marmolizado blanco gris', hex: '#D9D9D6', tipo: 'marmol' },
    marmolnd: { nombre: 'Marmolizado negro dorado', hex: '#2A2724', tipo: 'marmolOscuro' }
  };
  // Atajo por piso (carta, sección 3): la pared casi siempre es blanca, decide el piso.
  var PISOS = [
    { id: 'clara', nombre: 'Madera clara', tip: 'Con piso de madera clara queda bien casi todo; un gris o un azul navy hacen buen contraste.', van: ['gris-oscuro', 'azul-oscuro', 'gris-claro'] },
    { id: 'oscura', nombre: 'Madera oscura', tip: 'Con piso oscuro te recomendamos un mueble en tono claro para que el espacio no se vea pesado.', van: ['beige', 'blanco', 'gris-claro'] },
    { id: 'beige', nombre: 'Beige', tip: 'Con porcelanato beige quedan bien los tonos tierra (taupe, mocca, verde oliva) o un azul navy de contraste.', van: ['taupe', 'oliva', 'azul-oscuro', 'beige'] },
    { id: 'gris', nombre: 'Gris o blanco', tip: 'Con piso gris o blanco quedan bien los grises de otro tono, el azul navy, el rosa y el esmeralda.', van: ['gris-oscuro', 'gris-claro', 'azul-oscuro', 'rosa', 'esmeralda', 'negro'] }
  ];
  var PROPS = [
    { id: 'segura', nombre: 'Segura', tag: 'La que no falla', letra: 'S' },
    { id: 'equilibrada', nombre: 'Equilibrada', tag: 'La que más nos piden', letra: 'E' },
    { id: 'atrevida', nombre: 'Atrevida', tag: 'Para darle personalidad', letra: 'A' }
  ];
  var AVISO = 'Los colores de pantalla son aproximados: la muestra física manda.';
  var TILDES = { MARRON: 'Marrón', CAFE: 'Café', SALMON: 'Salmón', INDIGO: 'Índigo', PETROLEO: 'Petróleo', LIMON: 'Limón',
    OCEANO: 'Océano', CARBON: 'Carbón', ALGODON: 'Algodón', CAPUCHINO: 'Capuchino', TURQUIA: 'Turquía', BELGICA: 'Bélgica' };

  // ---------- utilidades ----------
  function $(s, c) { return (c || root).querySelector(s); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) { return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/^tela\s+/, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function bonito(s) {
    return String(s || '').toLowerCase().split(/\s+/).map(function (w) {
      var t = TILDES[w.toUpperCase()]; if (t) return t;
      return w ? w.charAt(0).toUpperCase() + w.slice(1) : w;
    }).join(' ');
  }
  function abs(u) { u = u || ''; return /^https?:/.test(u) ? u : (u ? CRM + (u.charAt(0) === '/' ? '' : '/') + u : ''); }
  function rgb(hex) { var n = parseInt(String(hex || '#999999').slice(1), 16); return [n >> 16, (n >> 8) & 255, n & 255]; }
  function sombra(hex, amt) {
    var c = rgb(hex).map(function (v) { return Math.max(0, Math.min(255, Math.round(amt < 0 ? v * (1 + amt) : v + (255 - v) * amt))); });
    return '#' + ((1 << 24) + (c[0] << 16) + (c[1] << 8) + c[2]).toString(16).slice(1);
  }
  function dist(a, b) { var x = rgb(a), y = rgb(b); return Math.hypot(x[0] - y[0], x[1] - y[1], x[2] - y[2]); }
  function y(lista) { return lista.length <= 1 ? (lista[0] || '') : lista.slice(0, -1).join(', ') + ' y ' + lista[lista.length - 1]; }
  var ICO_FLECHA = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
  var ICO_CHECK = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

  // =====================================================================================
  // ESCENA: sala dibujada con cajas CSS (puerto en limpio de «Sala Escena» del diseño v2)
  // =====================================================================================
  function fondoTela(t) {
    var capa = 'repeating-linear-gradient(0deg, rgba(255,255,255,0.05) 0 1px, transparent 1px 3px), repeating-linear-gradient(90deg, rgba(0,0,0,0.05) 0 1px, transparent 1px 3px), ';
    if (t && t.img) return 'url("' + t.img + '") center / cover no-repeat, ' + (t.hex || '#D8D2C8');
    return capa + ((t && t.hex) || '#E3DED5');
  }
  function fondoMadera(w) {
    if (w.tipo === 'madera') return 'repeating-linear-gradient(90deg, rgba(60,30,10,0.10) 0 2px, transparent 2px 11px), linear-gradient(180deg, rgba(255,255,255,0.22), rgba(255,255,255,0) 60%), ' + w.hex;
    if (w.tipo === 'marmol') return 'linear-gradient(112deg, transparent 38%, rgba(110,110,110,0.35) 40%, transparent 42%), linear-gradient(66deg, transparent 62%, rgba(130,130,130,0.25) 63%, transparent 65%), linear-gradient(180deg, rgba(255,255,255,0.3), transparent), ' + w.hex;
    if (w.tipo === 'marmolOscuro') return 'linear-gradient(112deg, transparent 38%, rgba(198,161,91,0.75) 39.5%, transparent 41%), linear-gradient(66deg, transparent 62%, rgba(198,161,91,0.45) 63%, transparent 64.5%), linear-gradient(180deg, rgba(255,255,255,0.12), transparent), ' + w.hex;
    return 'linear-gradient(180deg, rgba(255,255,255,0.18), rgba(255,255,255,0) 60%), ' + w.hex;
  }
  function caja(css, hijos) {
    var d = document.createElement('div');
    d.style.cssText = 'position:absolute;' + css;
    (hijos || []).forEach(function (h) { d.appendChild(h); });
    return d;
  }
  function pieza(l, t, w, h, r, bg, extra) { return caja('left:' + l + 'px;top:' + t + 'px;width:' + w + 'px;height:' + h + 'px;border-radius:' + r + ';background:' + bg + ';' + (extra || '')); }
  function pata(l, t, h, c, atras) { return caja('left:' + l + 'px;top:' + t + 'px;width:9px;height:' + h + 'px;background:' + c + ';border-radius:0 0 3px 3px;transform:skewX(' + (atras ? 0 : (l < 200 ? 8 : -8)) + 'deg);' + (atras ? 'opacity:0.75;' : '')); }
  function sofa(t) {
    var bg = fondoTela(t), L = '#8A6440', g = function (a) { return 'linear-gradient(180deg, ' + a + '), '; };
    var esp = g('rgba(255,255,255,0.12) 0%, rgba(255,255,255,0) 40%, rgba(0,0,0,0.16) 100%') + bg, asi = g('rgba(255,255,255,0.20), rgba(0,0,0,0.04)') + bg;
    return caja('inset:0;', [
      pata(70, 162, 14, sombra(L, -0.3), true), pata(362, 162, 14, sombra(L, -0.3), true), pata(28, 164, 20, L), pata(403, 164, 20, L),
      pieza(24, 0, 392, 104, '22px 22px 6px 6px', g('rgba(0,0,0,0.22), rgba(0,0,0,0.26)') + bg),
      pieza(34, 6, 124, 94, '16px 16px 8px 8px', esp, 'box-shadow:inset 0 -6px 10px rgba(0,0,0,0.10);'),
      pieza(158, 6, 124, 94, '16px 16px 8px 8px', esp, 'box-shadow:inset 0 -6px 10px rgba(0,0,0,0.10);'),
      pieza(282, 6, 124, 94, '16px 16px 8px 8px', esp, 'box-shadow:inset 0 -6px 10px rgba(0,0,0,0.10);'),
      pieza(34, 96, 124, 44, '8px 8px 4px 4px', asi, 'box-shadow:0 2px 0 rgba(0,0,0,0.08);'),
      pieza(158, 96, 124, 44, '8px 8px 4px 4px', asi, 'box-shadow:0 2px 0 rgba(0,0,0,0.08);'),
      pieza(282, 96, 124, 44, '8px 8px 4px 4px', asi, 'box-shadow:0 2px 0 rgba(0,0,0,0.08);'),
      pieza(26, 138, 388, 30, '4px', g('rgba(0,0,0,0.10), rgba(0,0,0,0.22)') + bg),
      pieza(0, 46, 60, 122, '26px 18px 6px 8px', 'linear-gradient(90deg, rgba(255,255,255,0.14), rgba(0,0,0,0.10)), ' + bg, 'box-shadow:inset 0 8px 10px -6px rgba(255,255,255,0.25), 2px 0 6px rgba(0,0,0,0.10);'),
      pieza(380, 46, 60, 122, '18px 26px 8px 6px', 'linear-gradient(90deg, rgba(255,255,255,0.06), rgba(0,0,0,0.18)), ' + bg, 'box-shadow:inset 0 8px 10px -6px rgba(255,255,255,0.25), -2px 0 6px rgba(0,0,0,0.10);')
    ]);
  }
  function poltrona(hex) {
    var bg = fondoTela({ hex: hex }), L = '#8A6440';
    return caja('inset:0;', [
      pata(10, 120, 18, L), pata(117, 120, 18, L),
      pieza(14, 0, 108, 86, '20px 20px 6px 6px', 'linear-gradient(180deg, rgba(255,255,255,0.12), rgba(0,0,0,0.16)), ' + bg),
      pieza(18, 76, 100, 32, '8px 8px 4px 4px', 'linear-gradient(180deg, rgba(255,255,255,0.20), rgba(0,0,0,0.04)), ' + bg),
      pieza(16, 104, 104, 20, '4px', 'linear-gradient(180deg, rgba(0,0,0,0.10), rgba(0,0,0,0.22)), ' + bg),
      pieza(0, 40, 26, 84, '14px 12px 5px 6px', 'linear-gradient(90deg, rgba(255,255,255,0.14), rgba(0,0,0,0.10)), ' + bg),
      pieza(110, 40, 26, 84, '12px 14px 6px 5px', 'linear-gradient(90deg, rgba(255,255,255,0.04), rgba(0,0,0,0.18)), ' + bg)
    ]);
  }
  function mesa(w) {
    var p = (w.tipo === 'marmol' || w.tipo === 'marmolOscuro') ? '#2E2B28' : sombra(w.hex, -0.18);
    return caja('inset:0;', [
      caja('left:44px;top:14px;width:8px;height:40px;background:' + sombra(p, -0.2) + ';'),
      caja('left:178px;top:14px;width:8px;height:40px;background:' + sombra(p, -0.2) + ';'),
      caja('left:16px;top:14px;width:10px;height:50px;background:' + p + ';border-radius:0 0 2px 2px;'),
      caja('left:204px;top:14px;width:10px;height:50px;background:' + p + ';border-radius:0 0 2px 2px;'),
      caja('left:0;top:0;width:230px;height:14px;border-radius:6px 6px 2px 2px;background:' + fondoMadera(w) + ';'),
      caja('left:0;top:12px;width:230px;height:10px;border-radius:0 0 3px 3px;background:' + sombra(w.hex, -0.16) + ';box-shadow:0 6px 10px rgba(38,38,38,0.16);')
    ]);
  }
  function cojin(hex, tela) {
    var bg = hex ? fondoTela({ hex: hex }) : 'linear-gradient(rgba(0,0,0,0.06), rgba(0,0,0,0.06)), ' + fondoTela(tela);
    return caja('left:0;top:0;width:86px;height:80px;border-radius:20px 20px 14px 14px;box-shadow:0 7px 10px rgba(38,38,38,0.20);background:radial-gradient(ellipse at 40% 32%, rgba(255,255,255,0.22), rgba(255,255,255,0) 60%), linear-gradient(180deg, rgba(0,0,0,0) 55%, rgba(0,0,0,0.16)), ' + bg + ';');
  }
  function tapete(hex, textura) { var t = tapeteConTextura(hex, textura); if (t) return t; return caja('inset:0;background:repeating-linear-gradient(0deg, rgba(255,255,255,0.06) 0 1px, transparent 1px 3px), ' + hex + ';box-shadow:inset 0 0 0 7px rgba(255,255,255,0.14), inset 0 0 0 8px rgba(0,0,0,0.06);'); }
  function piso(id) {
    var F = { clara: ['#D8BB95', 'rgba(110,70,30,0.20)', 'rgba(110,70,30,0.10)', 'tabla'], oscura: ['#6E4C36', 'rgba(25,12,5,0.38)', 'rgba(25,12,5,0.18)', 'tabla'],
      beige: ['#DDD3C2', 'rgba(130,105,80,0.20)', 'rgba(130,105,80,0.20)', 'baldosa'], gris: ['#DCDCD9', 'rgba(90,90,90,0.16)', 'rgba(90,90,90,0.16)', 'baldosa'],
      // pisos de los estilos
      media: ['#B48A62', 'rgba(70,40,15,0.26)', 'rgba(70,40,15,0.12)', 'tabla'], roble: ['#E2CDAA', 'rgba(120,85,45,0.16)', 'rgba(120,85,45,0.08)', 'tabla'],
      porcelanato: ['#C8C9C9', 'rgba(255,255,255,0.45)', 'rgba(255,255,255,0.30)', 'baldosa'], palido: ['#EADFD1', 'rgba(140,110,80,0.13)', 'rgba(140,110,80,0.07)', 'tabla'] }[id] || ['#D8BB95', 'rgba(110,70,30,0.2)', 'rgba(110,70,30,0.1)', 'tabla'];
    var pat = F[3] === 'tabla'
      ? 'repeating-linear-gradient(90deg, ' + F[1] + ' 0 2px, transparent 2px 70px, ' + F[2] + ' 70px 140px, ' + F[1] + ' 140px 142px, transparent 142px 230px, ' + F[2] + ' 230px 300px)'
      : 'repeating-linear-gradient(90deg, ' + F[1] + ' 0 2px, transparent 2px 150px), repeating-linear-gradient(0deg, ' + F[2] + ' 0 2px, transparent 2px 150px)';
    return caja('inset:0;background:' + F[0] + ';', [caja('left:-100%;top:0;width:300%;height:520px;transform-origin:50% 0;transform:perspective(520px) rotateX(58deg);background:' + pat + ';')]);
  }

  // ---------- AMBIENTES POR ESTILO (5-oct-2026, aprobado por Daniel) ----------
  // Cada estilo (paleta de la carta) viste la salita a su manera: pared, piso, luz, tapete y unos pocos objetos.
  // El SOFÁ no cambia. Sin estilo (cuando el cliente elige por TONO) = la escena neutra de siempre.
  // MISMO bloque en la web (tema Shopify, assets/saira-combina.js) y en el CRM (public/app/saira-escena-sala.js):
  // si cambia en uno, copiarlo al otro. Coordenadas del grupo de la sala (800×500): el piso empieza en y=330,
  // el sofá ocupa x 150–590, la poltrona x 614–750, la mesa x 262–492 (tapa en y=366).
  // Solo cajas CSS y SVG en línea (nada de imágenes): liviano en celulares de gama media.
  var AMB_PARED_NEUTRA = '#F3F0EA';
  var AMB_LUZ_NEUTRA = 'left:320px;top:-180px;width:360px;height:520px;background:rgba(255,255,255,0.55);transform:skewX(-14deg);filter:blur(28px);';
  function ambSvg(viewBox, cuerpo) {
    return 'url("data:image/svg+xml,' + encodeURIComponent("<svg xmlns='http://www.w3.org/2000/svg' viewBox='" + viewBox + "' preserveAspectRatio='none'>" + cuerpo + '</svg>') + '") center / 100% 100% no-repeat';
  }
  function ambObj(hijos) { return caja('left:0;top:0;width:800px;height:500px;pointer-events:none;', hijos); }
  function ambSombra(cx, y, w, a) {
    return caja('left:' + (cx - w / 2) + 'px;top:' + (y - 8) + 'px;width:' + w + 'px;height:16px;border-radius:50%;background:radial-gradient(ellipse at 50% 50%, rgba(38,38,38,' + (a || 0.22) + '), rgba(38,38,38,0) 70%);');
  }
  function ambHoja(x, y, w, h, ang, color) {
    return caja('left:' + (x - w / 2) + 'px;top:' + (y - h) + 'px;width:' + w + 'px;height:' + h + 'px;border-radius:50% 50% 50% 50% / 64% 64% 36% 36%;transform-origin:50% 100%;transform:rotate(' + ang + 'deg);background:linear-gradient(90deg, rgba(0,0,0,0.12), rgba(255,255,255,0.10) 48%, rgba(0,0,0,0.14)), ' + color + ';');
  }
  function ambMata(x, y, hojas, colores) {
    return hojas.map(function (f, i) { return ambHoja(x, y, f[0], f[1], f[2], colores[i % colores.length]); });
  }
  function ambMarco(l, t, w, h, borde, lienzo, mat) {
    return caja('left:' + l + 'px;top:' + t + 'px;width:' + w + 'px;height:' + h + 'px;background:' + borde + ';box-shadow:0 6px 12px -4px rgba(38,38,38,0.22);', [
      caja('left:' + mat + 'px;top:' + mat + 'px;right:' + mat + 'px;bottom:' + mat + 'px;background:' + lienzo + ';box-shadow:inset 0 1px 3px rgba(0,0,0,0.12);')
    ]);
  }
  var AMB_DORADO = 'linear-gradient(135deg, #B08A45, #E6CC8E 28%, #B9924C 52%, #E0C27E 76%, #A9823F)';
  function ambCortina(l, ancho, tela, opac, barra) {
    return [
      caja('left:' + (l + 30) + 'px;top:36px;width:' + (ancho + 10) + 'px;height:228px;background:linear-gradient(180deg, #EEF3F4, #DFE8EA);box-shadow:inset 0 0 0 5px #FAF8F3, inset 0 0 0 6px rgba(0,0,0,0.06);'),
      caja('left:' + (l + 30) + 'px;top:262px;width:' + (ancho + 10) + 'px;height:7px;background:#F7F4EE;box-shadow:0 2px 3px rgba(38,38,38,0.08);'),
      caja('left:' + l + 'px;top:22px;width:' + ancho + 'px;height:328px;opacity:' + opac + ';clip-path:polygon(0 0, 100% 0, 78% 52%, 92% 100%, 0 100%);background:repeating-linear-gradient(90deg, rgba(0,0,0,0.07) 0 5px, rgba(255,255,255,0.16) 5px 11px, rgba(0,0,0,0.03) 11px 16px), ' + tela + ';'),
      caja('left:' + (l - 8) + 'px;top:16px;width:' + (ancho + 70) + 'px;height:5px;border-radius:3px;background:' + barra + ';box-shadow:0 1px 2px rgba(38,38,38,0.18);')
    ];
  }
  function ambLamparaPie(x, metal, pantalla, domo) {
    return [
      caja('left:' + (x - 16) + 'px;top:342px;width:32px;height:6px;border-radius:50%;background:' + metal + ';'),
      caja('left:' + (x - 1.5) + 'px;top:124px;width:3px;height:221px;background:' + metal + ';'),
      caja('left:' + (x - 44) + 'px;top:118px;width:88px;height:90px;background:radial-gradient(ellipse at 50% 8%, rgba(255,232,190,0.55), rgba(255,232,190,0) 68%);'),
      domo
        ? caja('left:' + (x - 25) + 'px;top:98px;width:50px;height:28px;border-radius:26px 26px 3px 3px;background:' + pantalla + ';')
        : caja('left:' + (x - 23) + 'px;top:92px;width:46px;height:36px;clip-path:polygon(22% 0, 78% 0, 100% 100%, 0 100%);background:' + pantalla + ';')
    ];
  }

  var AMBIENTES = {
    // Tierra cálida: pared arena, madera media, luz cálida de tarde, tapete de yute, matera de barro, cuadro abstracto tierra.
    tierra: {
      pared: 'linear-gradient(100deg, rgba(255,214,170,0) 35%, rgba(255,200,150,0.14)), #E9DAC4', piso: 'media', tapete: 'yute',
      luz: 'left:400px;top:-200px;width:420px;height:560px;background:rgba(255,206,150,0.32);transform:skewX(-24deg);filter:blur(34px);',
      fondo: function () {
        return [
          ambObj([ambMarco(310, 80, 120, 78, '#8C6440', ambSvg('0 0 120 80', "<rect width='120' height='80' fill='#F1E6D6'/><circle cx='44' cy='44' r='22' fill='#B9653F'/><path d='M62 80 V48 a20 20 0 0 1 40 0 V80Z' fill='#C9A35C'/><rect x='18' y='58' width='40' height='22' fill='#8A5A3A' opacity='.85'/>"), 6)]),
          ambObj([ambSombra(80, 350, 96, 0.26),
            caja('left:40px;top:282px;width:80px;height:12px;border-radius:2px;background:#A55634;'),
            caja('left:44px;top:292px;width:72px;height:58px;clip-path:polygon(0 0, 100% 0, 86% 100%, 14% 100%);background:linear-gradient(90deg, rgba(0,0,0,0.14), rgba(255,255,255,0.12) 42%, rgba(0,0,0,0.18)), #B4643F;')
          ].concat(ambMata(80, 286, [[16, 70, -58], [20, 92, -36], [22, 112, -16], [24, 128, 2], [22, 110, 20], [20, 90, 38], [16, 72, 58]], ['#6E7D48', '#7F8E53', '#5F6E3E'])))
        ];
      },
      frente: function () { return []; }
    },
    // Nórdica clara: pared blanca, roble claro, luz fría de ventana, planta grande en canasta, lámpara negra fina, cuadro de línea.
    nordica: {
      pared: 'linear-gradient(80deg, rgba(225,236,250,0.35), rgba(225,236,250,0) 45%), #F6F5F2', piso: 'roble', tapete: null,
      luz: 'left:20px;top:-170px;width:300px;height:540px;background:rgba(228,240,255,0.62);transform:skewX(12deg);filter:blur(26px);',
      fondo: function () {
        return [
          ambObj([ambMarco(322, 80, 100, 78, '#1E1E1E', ambSvg('0 0 100 82', "<rect width='100' height='82' fill='#FBFAF7'/><path d='M18 64 C 28 26, 46 18, 50 40 S 66 72, 82 22' fill='none' stroke='#1E1E1E' stroke-width='1.6' stroke-linecap='round'/><circle cx='70' cy='30' r='5' fill='none' stroke='#1E1E1E' stroke-width='1.2'/>"), 2)]),
          ambObj(ambLamparaPie(602, '#1E1E1E', 'linear-gradient(90deg, #2C2C2C, #141414)', false)),
          ambObj([ambSombra(80, 350, 120, 0.24)].concat(ambMata(80, 282, [[36, 92, -56], [44, 124, -38], [48, 152, -20], [52, 178, -3], [48, 150, 16], [42, 120, 34], [36, 94, 54], [40, 136, 6]], ['#4E6B4C', '#5E7B57', '#43603F'])).concat([
            caja('left:28px;top:272px;width:104px;height:78px;clip-path:polygon(0 0, 100% 0, 90% 100%, 10% 100%);background:repeating-linear-gradient(45deg, rgba(90,60,30,0.18) 0 3px, transparent 3px 7px), repeating-linear-gradient(-45deg, rgba(90,60,30,0.14) 0 3px, transparent 3px 7px), linear-gradient(90deg, rgba(0,0,0,0.10), rgba(255,255,255,0.10) 45%, rgba(0,0,0,0.12)), #CFB48A;'),
            caja('left:26px;top:268px;width:108px;height:8px;border-radius:3px;background:#BFA275;')
          ]))
        ];
      },
      frente: function () { return []; }
    },
    // Moderna en contraste: pared blanca, porcelanato gris, lámpara de arco negra, cuadro geométrico blanco y negro.
    contraste: {
      pared: '#F4F4F2', piso: 'porcelanato', tapete: null,
      luz: 'left:330px;top:-180px;width:340px;height:520px;background:rgba(255,255,255,0.5);transform:skewX(-14deg);filter:blur(24px);',
      fondo: function () {
        return [
          ambObj([ambMarco(266, 80, 118, 78, '#141414', ambSvg('0 0 120 82', "<rect width='120' height='82' fill='#FAFAF8'/><rect x='14' y='14' width='36' height='54' fill='#141414'/><circle cx='80' cy='38' r='20' fill='none' stroke='#141414' stroke-width='2'/><path d='M58 68 A22 22 0 0 1 102 68Z' fill='#141414'/>"), 3)]),
          ambObj([
            caja('left:486px;top:46px;width:262px;height:300px;border-top:3px solid #1A1A1A;border-right:3px solid #1A1A1A;border-top-right-radius:250px 270px;'),
            caja('left:722px;top:340px;width:50px;height:10px;border-radius:50%;background:#1A1A1A;'),
            caja('left:486px;top:46px;width:2px;height:22px;background:#1A1A1A;'),
            caja('left:446px;top:96px;width:84px;height:86px;background:radial-gradient(ellipse at 50% 0%, rgba(255,236,205,0.6), rgba(255,236,205,0) 68%);'),
            caja('left:458px;top:66px;width:58px;height:30px;border-radius:30px 30px 3px 3px;background:linear-gradient(180deg, #2B2B2B, #0F0F0F);')
          ])
        ];
      },
      frente: function () { return []; }
    },
    // Azul clásico: pared blanco hueso, madera media, cortina, cuadro con marco dorado, tapete de estampado clásico.
    azul: {
      pared: '#F0EADF', piso: 'media', tapete: 'clasico',
      luz: 'left:300px;top:-180px;width:360px;height:520px;background:rgba(255,246,228,0.5);transform:skewX(-14deg);filter:blur(28px);',
      fondo: function () {
        return [
          ambObj(ambCortina(12, 76, '#E3D8C6', 1, 'linear-gradient(90deg, #A8844A, #D9BC85, #A8844A)')),
          ambObj([ambMarco(304, 76, 132, 84, AMB_DORADO, ambSvg('0 0 120 80', "<rect width='120' height='80' fill='#DCE3E4'/><path d='M0 52 Q 30 30 58 46 T 120 40 V80 H0Z' fill='#8FA39A'/><path d='M0 62 Q 40 48 80 60 T 120 58 V80 H0Z' fill='#6D857F'/><ellipse cx='86' cy='22' rx='9' ry='9' fill='#F3EBD8'/>"), 9)])
        ];
      },
      frente: function () { return []; }
    },
    // Botánica: pared verde salvia muy suave, varias plantas, lámpara de latón, marco dorado.
    botanica: {
      pared: '#DEE5D6', piso: 'clara', tapete: null,
      luz: 'left:320px;top:-180px;width:360px;height:520px;background:rgba(250,255,238,0.5);transform:skewX(-14deg);filter:blur(28px);',
      fondo: function () {
        return [
          ambObj([ambMarco(322, 80, 98, 80, AMB_DORADO, ambSvg('0 0 100 84', "<rect width='100' height='84' fill='#F4EFE3'/><path d='M50 74 C 50 50, 50 30, 50 12' stroke='#476B4E' stroke-width='1.4' fill='none'/><path d='M50 30 C 36 26, 30 18, 32 10 C 42 12, 48 20, 50 30Z M50 44 C 64 40, 70 32, 68 24 C 58 26, 52 34, 50 44Z M50 58 C 36 54, 30 46, 32 38 C 42 40, 48 48, 50 58Z' fill='#5E8461'/>"), 5)]),
          ambObj(ambLamparaPie(602, '#B8924F', 'linear-gradient(180deg, #D8B873, #A7813F)', true)),
          ambObj([caja('left:715px;top:0;width:1px;height:96px;background:#9C8A6E;'),
            caja('left:700px;top:94px;width:32px;height:24px;border-radius:3px 3px 12px 12px;background:linear-gradient(90deg, rgba(0,0,0,0.08), rgba(255,255,255,0.3) 45%, rgba(0,0,0,0.1)), #EFEBE3;')
          ].concat(ambMata(716, 98, [[12, 30, -64], [12, 34, -30], [12, 36, 0], [12, 34, 30], [12, 30, 64]], ['#4F7D57', '#3F6B4A'])).concat([
            ambHoja(708, 112, 8, 44, 174, '#4F7D57'), ambHoja(717, 114, 8, 58, 180, '#3F6B4A'), ambHoja(726, 112, 8, 40, 186, '#5E8C63')
          ])),
          ambObj([ambSombra(80, 350, 104, 0.24)].concat(ambMata(80, 292, [[26, 120, -40], [30, 160, -22], [32, 196, -6], [30, 168, 12], [26, 130, 30], [22, 96, -58], [22, 98, 52]], ['#3F6B4A', '#4F7D57', '#355E40'])).concat([
            caja('left:40px;top:290px;width:80px;height:60px;border-radius:4px 4px 16px 16px;background:linear-gradient(90deg, rgba(0,0,0,0.10), rgba(255,255,255,0.35) 40%, rgba(0,0,0,0.12)), #EFEBE3;')
          ]))
        ];
      },
      frente: function () {
        return [ambObj([caja('left:296px;top:344px;width:26px;height:24px;border-radius:3px 3px 9px 9px;background:linear-gradient(90deg, rgba(0,0,0,0.08), rgba(255,255,255,0.3) 45%, rgba(0,0,0,0.1)), #D9CDB8;')]
          .concat(ambMata(309, 346, [[10, 26, -42], [11, 32, -14], [11, 34, 10], [10, 26, 38]], ['#4F7D57', '#3F6B4A'])))];
      }
    },
    // Suave romántica: pared rosa empolvado muy suave, piso claro, cortina de lino, jarrón con flores.
    romantica: {
      pared: '#F2E3DD', piso: 'palido', tapete: null,
      luz: 'left:40px;top:-170px;width:320px;height:540px;background:rgba(255,242,236,0.6);transform:skewX(10deg);filter:blur(28px);',
      fondo: function () {
        return [
          ambObj(ambCortina(12, 80, 'rgba(250,247,242,0.95)', 0.82, 'linear-gradient(90deg, #E7DDD2, #F5EFE8, #E7DDD2)')),
          ambObj([caja('left:334px;top:66px;width:72px;height:96px;border-radius:36px 36px 3px 3px;border:4px solid #D9C3A5;box-shadow:0 6px 12px -4px rgba(38,38,38,0.20);background:linear-gradient(150deg, rgba(255,255,255,0.75), rgba(255,255,255,0) 45%, rgba(255,255,255,0.35) 70%, rgba(255,255,255,0)), linear-gradient(180deg, #EDE6E2, #DCD3CF);')])
        ];
      },
      frente: function () {
        var flor = function (x, y, r, c) { return caja('left:' + (x - r) + 'px;top:' + (y - r) + 'px;width:' + (2 * r) + 'px;height:' + (2 * r) + 'px;border-radius:50%;background:radial-gradient(circle at 42% 38%, rgba(255,255,255,0.45), rgba(255,255,255,0) 55%), radial-gradient(circle at 50% 50%, rgba(0,0,0,0.10) 0 18%, rgba(0,0,0,0) 22%), ' + c + ';'); };
        return [ambObj(ambMata(420, 334, [[7, 34, -40], [7, 30, 44], [6, 26, -12]], ['#9DB09A', '#8CA28A']).concat([
          flor(404, 298, 12, '#E9A7A4'), flor(426, 286, 13, '#F3C9BD'), flor(447, 300, 11, '#D98E8E'), flor(414, 314, 10, '#F6DCCF'), flor(438, 314, 10, '#E9A7A4'),
          caja('left:406px;top:322px;width:28px;height:46px;border-radius:12px 12px 8px 8px / 18px 18px 8px 8px;background:linear-gradient(90deg, rgba(0,0,0,0.08), rgba(255,255,255,0.55) 40%, rgba(0,0,0,0.10)), #F5F0EB;box-shadow:0 3px 5px rgba(38,38,38,0.12);')
        ]))];
      }
    }
  };
  function ambiente(id) { return (id && AMBIENTES[id]) || null; }
  /** Textura del tapete según el estilo: yute (tejido) o estampado clásico; null = el liso de siempre. */
  function tapeteConTextura(hex, textura) {
    if (textura === 'yute') {
      return caja('inset:0;background:repeating-linear-gradient(0deg, rgba(90,60,25,0.16) 0 2px, transparent 2px 5px), repeating-linear-gradient(90deg, rgba(255,255,255,0.12) 0 2px, transparent 2px 6px), ' + ((!hex || hex === '#E7E1D6') ? '#CDB287' : hex) + ';box-shadow:inset 0 0 0 6px rgba(120,85,45,0.18), inset 0 0 0 7px rgba(0,0,0,0.06);');
    }
    if (textura === 'clasico') {
      var base = hex || '#E7DCC6';
      return caja('inset:0;background:repeating-linear-gradient(45deg, rgba(47,74,107,0.10) 0 2px, transparent 2px 22px), repeating-linear-gradient(-45deg, rgba(47,74,107,0.10) 0 2px, transparent 2px 22px), ' + base + ';box-shadow:inset 0 0 0 5px ' + sombra(base, -0.12) + ', inset 0 0 0 11px rgba(47,74,107,0.32), inset 0 0 0 13px ' + base + ';');
    }
    return null;
  }
  /** Cambia los objetos de un estilo a otro: lo viejo se funde, lo nuevo entra subiendo 10 px (sin rebote). */
  function ambPoner(cont, nodos, animar, red) {
    Array.prototype.slice.call(cont.children).forEach(function (o) {
      if (!animar || !o.animate) { o.remove(); return; }
      var a = o.animate([{ opacity: 1 }, { opacity: 0 }], { duration: red ? 180 : 220, easing: E, fill: 'forwards' });
      a.onfinish = function () { o.remove(); };
    });
    nodos.forEach(function (n, i) {
      cont.appendChild(n);
      if (!animar || !n.animate) return;
      if (red) n.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 180, easing: E, fill: 'backwards' });
      else n.animate([{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 420, delay: 160 + i * 70, easing: E, fill: 'backwards' });
    });
  }

  function Escena(contenedor, opciones) {
    opciones = opciones || {};
    var mini = !!opciones.mini;
    contenedor.classList.add('scc-esc');
    contenedor.innerHTML = '';
    var esc_ = caja('left:50%;bottom:0;width:4000px;height:1100px;transform-origin:50% 100%;');
    var pared = caja('left:0;right:0;top:0;bottom:170px;background:' + AMB_PARED_NEUTRA + ';');
    var tinte = caja('left:0;right:0;top:0;bottom:170px;opacity:0.06;');
    // La luz vive en coordenadas del grupo de la sala (800×500), como los objetos de los estilos.
    var luz = caja('left:1600px;bottom:0;width:800px;height:500px;pointer-events:none;');
    var pisoC = caja('left:0;right:0;bottom:0;height:170px;overflow:hidden;');
    var zocalo = caja('left:0;right:0;bottom:170px;height:7px;background:#E8E3DA;box-shadow:0 1px 0 rgba(38,38,38,0.06);');
    var sombraP = caja('left:0;right:0;bottom:120px;height:50px;background:linear-gradient(180deg, rgba(38,38,38,0.10), rgba(38,38,38,0));pointer-events:none;');
    var grupo = caja('left:1600px;bottom:0;width:800px;height:500px;');
    var sombraS = caja('left:120px;top:330px;width:660px;height:48px;background:radial-gradient(ellipse at 50% 40%, rgba(38,38,38,0.26), rgba(38,38,38,0) 70%);');
    var tapC = caja('left:110px;top:374px;width:580px;height:100px;clip-path:polygon(9% 0, 91% 0, 100% 100%, 0 100%);');
    var sofaC = caja('left:150px;top:172px;width:440px;height:184px;');
    var cojC = caja('left:0;top:0;width:800px;height:500px;pointer-events:none;');
    var polC = caja('left:614px;top:232px;width:136px;height:140px;');
    var mesaC = caja('left:262px;top:366px;width:230px;height:66px;');
    var ambFondo = caja('left:0;top:0;width:800px;height:500px;pointer-events:none;');
    var ambFrente = caja('left:0;top:0;width:800px;height:500px;pointer-events:none;');
    [ambFondo, sombraS, tapC, sofaC, cojC, polC, mesaC, ambFrente].forEach(function (n) { grupo.appendChild(n); });
    [pared, tinte, luz, pisoC, zocalo, sombraP, grupo].forEach(function (n) { esc_.appendChild(n); });
    contenedor.appendChild(esc_);

    function ajustar() {
      var w = contenedor.offsetWidth, h = contenedor.offsetHeight;
      if (!w || !h) return;
      var k = Math.min(h / 520, w / 760);
      esc_.style.transform = 'translateX(-50%) scale(' + k + ')';
    }
    ajustar();
    if (window.ResizeObserver) new ResizeObserver(ajustar).observe(contenedor);
    else window.addEventListener('resize', ajustar);

    function capa(box, nodo, o) {
      nodo.style.position = 'absolute'; nodo.style.inset = '0';
      box.appendChild(nodo);
      var listo = function () { if (nodo.parentNode !== box) return; while (nodo.previousSibling) box.removeChild(nodo.previousSibling); };
      if (o.inst || mini || !nodo.animate) { listo(); return; }
      var a;
      if (o.barrido && !quieto()) {
        var b = o.barrido;
        a = nodo.animate([{ clipPath: 'circle(0px at ' + b.x + 'px ' + b.y + 'px)' }, { clipPath: 'circle(' + b.R + 'px at ' + b.x + 'px ' + b.y + 'px)' }], { duration: 520, easing: E });
      } else {
        a = nodo.animate([{ opacity: 0 }, { opacity: 1 }], { duration: quieto() ? 180 : (o.dur || 320), easing: E });
      }
      a.onfinish = listo;
    }
    function origen(punto) {
      var W = sofaC.offsetWidth, H = sofaC.offsetHeight, x = W / 2, yy = H / 2;
      if (punto) {
        var r = sofaC.getBoundingClientRect(), k = r.width / W || 1;
        x = (punto.x - r.left) / k; yy = (punto.y - r.top) / k;
      }
      var R = Math.max.apply(null, [[0, 0], [W, 0], [0, H], [W, H]].map(function (p) { return Math.hypot(p[0] - x, p[1] - yy); }));
      return { x: x, y: yy, R: R };
    }
    function cojines(lista, tela, animar) {
      var pos = [[203, 194, -6], [327, 190, 0], [451, 194, 6]];
      var viejos = Array.prototype.slice.call(cojC.children);
      var inst = !animar || mini || !cojC.animate;
      var salida = quieto() ? 180 : 140;
      viejos.forEach(function (o) {
        if (inst) { o.remove(); return; }
        var a = o.animate([{ opacity: 1 }, { opacity: 0 }], { duration: salida, easing: E, fill: 'forwards' });
        a.onfinish = function () { o.remove(); };
      });
      lista.forEach(function (c, i) {
        var p = pos[i];
        var w = caja('left:' + p[0] + 'px;top:' + p[1] + 'px;width:86px;height:80px;transform:rotate(' + p[2] + 'deg);', [cojin(c, tela)]);
        cojC.appendChild(w);
        if (inst) return;
        if (quieto()) w.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 180, easing: E, fill: 'backwards' });
        else w.animate([{ transform: 'translateY(-16px) rotate(0deg)', opacity: 0 }, { transform: 'translateY(0) rotate(' + p[2] + 'deg)', opacity: 1 }],
          { duration: 320, delay: salida + i * 70, easing: E, fill: 'backwards' });
      });
    }
    var antes = null;
    function aplicar(L, o) {
      o = o || {};
      var inst = !antes || o.inst;
      var A = antes || {};
      var cambia = function (k) { return inst || JSON.stringify(A[k]) !== JSON.stringify(L[k]); };
      // Estilo: pared, luz y objetos propios; el piso del estilo solo si el cliente no dijo cuál es el suyo.
      var amb = ambiente(L.estilo), estiloCambia = cambia('estilo');
      var pisoEf = (amb && !L.pisoFijo) ? amb.piso : L.piso;
      if (estiloCambia) {
        capa(pared, caja('background:' + (amb ? amb.pared : AMB_PARED_NEUTRA) + ';'), { inst: inst, dur: 520 });
        capa(luz, caja('', [caja(amb ? amb.luz : AMB_LUZ_NEUTRA)]), { inst: inst, dur: 520 });
        ambPoner(ambFondo, amb ? amb.fondo() : [], !inst && !mini, quieto());
        ambPoner(ambFrente, amb ? amb.frente() : [], !inst && !mini, quieto());
      }
      if (cambia('tinte')) capa(tinte, caja('background:' + L.tinte + ';'), { inst: inst, dur: 520 });
      if (inst || pisoEf !== A.pisoEf) capa(pisoC, piso(pisoEf), { inst: inst, dur: 520 });
      if (cambia('tapete') || estiloCambia) capa(tapC, tapete(L.tapete, amb ? amb.tapete : null), { inst: inst });
      if (cambia('madera')) capa(mesaC, mesa(L.madera), { inst: inst });
      if (cambia('poltrona')) capa(polC, poltrona(L.poltrona), { inst: inst });
      if (cambia('tela')) capa(sofaC, sofa(L.tela), { inst: inst, barrido: inst ? null : origen(o.punto) });
      var cojCambia = cambia('cojines') || cambia('clave');
      if (cojCambia) cojines(L.cojines, L.tela, !inst);
      else if (cambia('tela') && L.cojines.some(function (c) { return !c; })) cojines(L.cojines, L.tela, false);
      antes = JSON.parse(JSON.stringify(L));
      antes.pisoEf = pisoEf;
    }
    return { aplicar: aplicar, ajustar: ajustar };
  }

  // =====================================================================================
  // DATOS
  // =====================================================================================
  var D = null;          // carta normalizada
  var ACC = {};          // clave -> { nombre, hex }
  var S = { grupo: null, tela: null, prop: 'equilibrada', estilo: null, piso: 'clara', pisoElegido: false, avisoAgotada: '' };
  var Q = new URLSearchParams(location.search);
  var PRUEBA = Q.get('cc') || '';

  function normalizar(d) {
    if (!d || !Array.isArray(d.grupos) || !Array.isArray(d.telas)) throw new Error('carta sin grupos/telas');
    var cat = d.acompanantes_catalogo || {};
    Object.keys(cat).forEach(function (k) { ACC[k] = { nombre: cat[k].nombre, hex: cat[k].hex }; });
    var grupos = d.grupos.map(function (g) {
      var acomp = (g.acompanantes || []).map(function (a) {
        var x = { clave: a.clave, nombre: a.nombre || (ACC[a.clave] && ACC[a.clave].nombre) || a.clave, hex: a.hex || (ACC[a.clave] && ACC[a.clave].hex) || '#CCCCCC', uso: a.uso || '', tendencia: !!a.tendencia };
        if (!ACC[a.clave]) ACC[a.clave] = { nombre: x.nombre, hex: x.hex };
        return x;
      });
      var corto = g.nombre_corto || String(g.nombre || '').split(/,| y /)[0].trim();
      return { id: g.id, nombre: g.nombre, corto: corto, hex: g.hex || '#CCCCCC', acompanantes: acomp, madera: g.madera || '', maderas: Array.isArray(g.maderas) ? g.maderas : null, evitar: g.evitar || '', frase: g.frase || '', propuestas: g.propuestas || {} };
    });
    var telas = d.telas.filter(function (t) { return !t.agotado; }).map(function (t) {
      // id interno = «coleccion-color» (estable, legible en la URL y siempre texto); el id del CRM es numérico y se guarda aparte.
      return { id: norm(t.coleccion + ' ' + t.color), crm: t.id == null ? '' : String(t.id), coleccion: bonito(t.coleccion), color: bonito(t.color), grupo: t.grupo, img: abs(t.swatch_url), hex: t.hex || null };
    });
    var todas = d.telas.map(function (t) { return { id: norm(t.coleccion + ' ' + t.color), crm: t.id == null ? '' : String(t.id), grupo: t.grupo, agotado: !!t.agotado, nombre: bonito(t.coleccion) + ' ' + bonito(t.color) }; });
    var mapaSofa = { beige: 'beige', grisclaro: 'gris-claro', grafito: 'gris-oscuro', navy: 'azul-oscuro', esmeralda: 'esmeralda', rosapalo: 'rosa' };
    var paletas = (d.paletas || []).map(function (p) {
      var gid = p.grupo || mapaSofa[p.sofa];
      var ac = p.acentos || [];
      var pr = p.propuesta || { cojines: [ac[0] || null, ac[1] || null, ac[0] || null], tapete: null, poltrona: ac[3] || null, madera: 'natural' };
      return { id: p.id, nombre: p.nombre, para: p.para || '', grupo: gid, propuesta: pr, puntos: ac.slice(0, 5) };
    }).filter(function (p) { return grupos.some(function (g) { return g.id === p.grupo; }); });
    return { grupos: grupos, telas: telas, todas: todas, paletas: paletas };
  }
  function grupo(id) { for (var i = 0; i < D.grupos.length; i++) if (D.grupos[i].id === id) return D.grupos[i]; return null; }
  function telasDe(gid) { if (PRUEBA === 'sin' && S.grupo && gid === S.grupo.id) return []; return D.telas.filter(function (t) { return t.grupo === gid; }); }
  function parecidas(g) {
    return D.grupos.filter(function (x) { return x.id !== g.id && telasDe(x.id).length; })
      .sort(function (a, b) { return dist(a.hex, g.hex) - dist(b.hex, g.hex); }).slice(0, 2)
      .reduce(function (acc, x) { return acc.concat(telasDe(x.id).slice(0, 3)); }, []);
  }
  function maderaDe(clave) {
    if (MADERAS[clave]) return MADERAS[clave];
    var k = norm(clave).split('-')[0];
    return MADERAS[k] || MADERAS.natural;
  }
  // «También le quedan»: las maderas del grupo SIN la que ya está puesta en la propuesta.
  function otrasMaderas(clave, m) {
    if (S.grupo.maderas) {
      return S.grupo.maderas.filter(function (k) { return MADERAS[k] && MADERAS[k] !== m; })
        .map(function (k) { return MADERAS[k].nombre.toLowerCase(); });
    }
    var actual = norm(m.nombre).split('-')[0];
    return String(S.grupo.madera || '').split(/[,;]/).map(function (x) { return x.replace(/\s+también$/i, '').trim(); })
      .filter(function (x) { return x && norm(x).split('-')[0] !== actual; })
      .map(function (x) { return x.charAt(0).toLowerCase() + x.slice(1); });
  }
  function propuestaActual() {
    if (S.estilo) return S.estilo.propuesta;
    return (S.grupo.propuestas && S.grupo.propuestas[S.prop]) || { cojines: [null, null, null], tapete: null, poltrona: null, madera: 'natural' };
  }
  function hexAcc(k) { return k && ACC[k] ? ACC[k].hex : null; }
  function nomAcc(k) { return k && ACC[k] ? ACC[k].nombre.replace(/\s*\(.*\)$/, '').split(' / ')[0].toLowerCase() : ''; }
  function look() {
    var p = propuestaActual();
    var t = S.tela ? { img: S.tela.img, hex: S.tela.hex || S.grupo.hex } : { img: null, hex: S.grupo.hex };
    return {
      clave: (S.estilo ? 'e:' + S.estilo.id : S.prop) + '|' + S.grupo.id,
      // Por ESTILO la salita trae su propio ambiente (pared, piso, luz, objetos); por TONO, la escena neutra.
      estilo: S.estilo ? S.estilo.id : null, pisoFijo: S.pisoElegido,
      tela: t, tinte: S.estilo ? 'transparent' : S.grupo.hex, piso: S.piso,
      cojines: (p.cojines || [null, null, null]).slice(0, 3).map(hexAcc),
      poltrona: hexAcc(p.poltrona) || '#E6E0D5',
      tapete: hexAcc(p.tapete) || '#E7E1D6',
      madera: maderaDe(p.madera)
    };
  }
  function resumen() {
    var p = propuestaActual(), uniq = [];
    (p.cojines || []).forEach(function (k) { if (k && uniq.indexOf(k) < 0) uniq.push(k); });
    var partes = [];
    if (uniq.length) partes.push('cojines ' + y(uniq.map(nomAcc)));
    if (p.poltrona) partes.push('poltrona ' + nomAcc(p.poltrona));
    if (p.tapete && uniq.indexOf(p.tapete) < 0) partes.push('tapete ' + nomAcc(p.tapete));
    var md = maderaDe(p.madera);
    partes.push((/^marmol/.test(md.tipo) ? 'mesa en ' + md.nombre.toLowerCase() : 'madera ' + md.nombre));
    return partes;
  }

  // =====================================================================================
  // PINTAR
  // =====================================================================================
  var escena = null;
  var el = {
    estado: $('[data-scc-estado]'), pasos: $('[data-scc-pasos]'), escena: $('[data-scc-escena]'),
    etiqueta: $('[data-scc-etiqueta]'), barra: $('[data-scc-barra]'), cta: $('[data-scc-cta]')
  };

  function pintarPisos() {
    var h = '';
    PISOS.forEach(function (p) {
      h += '<button type="button" class="scc-chip" data-piso="' + p.id + '" aria-pressed="' + (S.pisoElegido && S.piso === p.id) + '">' + esc(p.nombre) + '</button>';
    });
    $('[data-scc-pisos]').innerHTML = h;
    var tip = $('[data-scc-piso-tip]');
    var p = PISOS.filter(function (x) { return x.id === S.piso; })[0];
    tip.textContent = S.pisoElegido && p ? p.tip : '';
    tip.hidden = !S.pisoElegido;
  }
  function ordenGrupos() {
    if (!S.pisoElegido) return D.grupos.slice();
    var p = PISOS.filter(function (x) { return x.id === S.piso; })[0];
    var van = (p && p.van) || [];
    return D.grupos.slice().sort(function (a, b) {
      var ia = van.indexOf(a.id), ib = van.indexOf(b.id);
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
    });
  }
  function muestraDeGrupo(g) {
    var t = telasDe(g.id)[0];
    return t ? 'background:url("' + t.img + '") center / cover, ' + g.hex : 'background:' + g.hex;
  }
  function pintarTonos() {
    var h = '';
    ordenGrupos().forEach(function (g) {
      var on = S.grupo && S.grupo.id === g.id;
      h += '<button type="button" class="scc-tono" data-grupo="' + g.id + '" aria-pressed="' + on + '">'
        + '<span class="scc-tono__mu" style=\'' + muestraDeGrupo(g) + '\'></span>'
        + '<span class="scc-tono__n">' + esc(g.corto) + '</span></button>';
    });
    $('[data-scc-tonos]').innerHTML = h;
  }
  function pintarEstilos() {
    var cont = $('[data-scc-estilos]');
    if (!D.paletas.length) { cont.closest('[data-scc-bloque-estilos]').hidden = true; return; }
    var h = '';
    D.paletas.forEach(function (p) {
      h += '<button type="button" class="scc-estilo" data-estilo="' + p.id + '" aria-pressed="' + (S.estilo && S.estilo.id === p.id ? 'true' : 'false') + '">'
        + '<span class="scc-estilo__esc" data-mini="' + p.id + '"></span>'
        + '<span class="scc-estilo__n">' + esc(p.nombre) + '</span>'
        + '<span class="scc-estilo__pt">' + p.puntos.map(function (k) { return '<i style="background:' + (hexAcc(k) || '#ccc') + '"></i>'; }).join('') + '</span></button>';
    });
    cont.innerHTML = h;
    D.paletas.forEach(function (p) {
      var g = grupo(p.grupo), t = telasDe(p.grupo)[0];
      var m = Escena(cont.querySelector('[data-mini="' + p.id + '"]'), { mini: true });
      m.aplicar({ clave: 'm', estilo: p.id, tela: { img: t ? t.img : null, hex: g.hex }, tinte: 'transparent', piso: 'clara',
        cojines: (p.propuesta.cojines || []).slice(0, 3).map(hexAcc), poltrona: hexAcc(p.propuesta.poltrona) || '#E6E0D5',
        tapete: hexAcc(p.propuesta.tapete) || '#E7E1D6', madera: maderaDe(p.propuesta.madera) }, { inst: true });
    });
  }
  function tarjetaTela(t) {
    var on = S.tela && S.tela.id === t.id;
    return '<button type="button" class="scc-tela" data-tela="' + esc(t.id) + '" aria-pressed="' + on + '">'
      + '<span class="scc-tela__mu"><img src="' + esc(t.img) + '" alt="" loading="lazy" decoding="async" width="88" height="88">'
      + '<span class="scc-tela__ok">' + ICO_CHECK + '</span></span>'
      + '<span class="scc-tela__c">' + esc(t.color) + '</span><span class="scc-tela__col">' + esc(t.coleccion) + '</span></button>';
  }
  function pintarTelas() {
    var lista = telasDe(S.grupo.id), h = '', cont = $('[data-scc-telas]'), info = $('[data-scc-telas-info]');
    if (!lista.length) {
      var p = parecidas(S.grupo);
      info.innerHTML = '<span class="scc-nota">Ahora no tenemos telas de este tono disponibles. Te mostramos las más parecidas.</span>';
      p.forEach(function (t) { h += tarjetaTela(t); });
    } else {
      info.innerHTML = '<span class="scc-cuenta">' + lista.length + (lista.length === 1 ? ' tela disponible' : ' telas disponibles') + '</span>'
        + (S.avisoAgotada ? '<span class="scc-nota">' + esc(S.avisoAgotada) + '</span>' : '');
      lista.forEach(function (t) { h += tarjetaTela(t); });
    }
    cont.innerHTML = h;
  }
  function pintarPropuesta(animar) {
    var seg = $('[data-scc-seg]');
    var idx = -1;
    PROPS.forEach(function (p, i) { if (!S.estilo && p.id === S.prop) idx = i; });
    seg.style.setProperty('--i', idx < 0 ? 0 : idx);
    seg.classList.toggle('is-nada', idx < 0);
    Array.prototype.forEach.call(seg.querySelectorAll('[data-prop]'), function (b) { b.setAttribute('aria-pressed', String(!S.estilo && b.getAttribute('data-prop') === S.prop)); });
    var meta = PROPS[idx < 0 ? 1 : idx];
    $('[data-scc-tag]').textContent = S.estilo ? ('Estilo ' + S.estilo.nombre) : meta.tag;
    $('[data-scc-tela-nom]').textContent = S.tela ? (S.tela.color + ' · ' + S.tela.coleccion) : S.grupo.corto;

    var p = propuestaActual(), usados = {};
    (p.cojines || []).forEach(function (k) { if (k) usados[k] = (usados[k] || []).concat('Cojines'); });
    if (p.tapete) usados[p.tapete] = (usados[p.tapete] || []).concat('Tapete');
    if (p.poltrona) usados[p.poltrona] = (usados[p.poltrona] || []).concat('Poltrona');
    var h = '';
    S.grupo.acompanantes.forEach(function (a, i) {
      var u = usados[a.clave];
      var donde = u ? u.filter(function (x, j) { return u.indexOf(x) === j; }).map(function (x, j) { return j ? x.toLowerCase() : x; }).join(' y ') : a.uso;
      h += '<li class="scc-acc' + (u ? ' is-usado' : '') + '" style="--d:' + (i * 50) + 'ms">'
        + '<span class="scc-acc__c" style="background:' + a.hex + '"></span>'
        + '<span class="scc-acc__t"><b>' + esc(a.nombre.replace(/\s*\(.*\)$/, '')) + '</b><small>' + esc(donde) + '</small></span>'
        + (a.tendencia ? '<span class="scc-acc__tend">Tendencia 2026</span>' : '') + '</li>';
    });
    var lista = $('[data-scc-acc]');
    lista.innerHTML = h;
    lista.classList.remove('is-entra');
    if (animar && !quieto()) { void lista.offsetWidth; lista.classList.add('is-entra'); }
    var m = maderaDe(p.madera);
    $('[data-scc-madera]').innerHTML = '<span class="scc-mad__mu" style="background:' + fondoMadera(m) + '"></span>'
      + '<span><b>' + (/^marmol/.test(m.tipo) ? 'Mesa en ' : 'Madera ') + esc(m.nombre.toLowerCase()) + '</b>' + (function () {
        var otras = otrasMaderas(p.madera, m);
        return otras.length ? '<small>También le quedan: ' + esc(y(otras)) + '</small>' : '';
      })() + '</span>';
    $('[data-scc-evitar]').textContent = S.grupo.evitar ? ('Mejor evita: ' + S.grupo.evitar.charAt(0).toLowerCase() + S.grupo.evitar.slice(1) + '.').replace(/\.\.$/, '.') : '';
    $('[data-scc-evitar]').hidden = !S.grupo.evitar;
    // La frase de la PROPUESTA elegida (sus cojines, tapete, poltrona y madera; CRM PR #3580). En un estilo, la del grupo.
    var pf = !S.estilo && S.grupo.propuestas && S.grupo.propuestas[S.prop];
    $('[data-scc-frase]').textContent = (pf && pf.frase) || S.grupo.frase;
  }
  function pintarEtiqueta() {
    var t = S.tela;
    el.etiqueta.innerHTML = (t ? '<span class="scc-etq__mu" style="background:url(&quot;' + esc(t.img) + '&quot;) center / cover"></span>' : '')
      + '<b>' + esc(t ? t.color : S.grupo.corto) + '</b><span>' + esc((t ? t.coleccion + ' · ' : '') + (S.estilo ? S.estilo.nombre : PROPS.filter(function (x) { return x.id === S.prop; })[0].nombre)) + '</span>';
  }
  function mensaje() {
    var t = S.tela, nombreProp = S.estilo ? ('el estilo ' + S.estilo.nombre) : ('la propuesta ' + PROPS.filter(function (x) { return x.id === S.prop; })[0].nombre);
    var sofaTxt = t ? ('sofá en ' + t.color + ' (' + t.coleccion + ')') : ('sofá en tono ' + S.grupo.corto.toLowerCase());
    var piso = S.pisoElegido ? (' Mi piso es ' + PISOS.filter(function (x) { return x.id === S.piso; })[0].nombre.toLowerCase() + '.') : '';
    var letra = S.estilo ? ('X' + S.estilo.id) : PROPS.filter(function (x) { return x.id === S.prop; })[0].letra;
    var txt = 'Hola, quiero asesoría con estos colores: ' + sofaTxt + ', ' + resumen().join(', ') + '. Vi ' + nombreProp + ' en la web.' + piso
      + ' [Ref CC-' + letra + '-' + S.grupo.id + ']';
    return typeof window.sairaWaConOrigen === 'function' ? window.sairaWaConOrigen(txt) : txt;
  }
  function pintarCTA() { el.cta.href = 'https://wa.me/' + WA + '?text=' + encodeURIComponent(mensaje()); }
  function sincronizarURL() {
    try {
      var u = new URL(location.href);
      u.searchParams.set('tono', S.grupo.id);
      if (S.tela) u.searchParams.set('tela', S.tela.id); else u.searchParams.delete('tela');
      if (S.estilo) { u.searchParams.set('estilo', S.estilo.id); u.searchParams.delete('p'); } else { u.searchParams.set('p', S.prop); u.searchParams.delete('estilo'); }
      if (S.pisoElegido) u.searchParams.set('piso', S.piso); else u.searchParams.delete('piso');
      history.replaceState(history.state, '', u.toString());
    } catch (e) { /* sin URL API: no pasa nada */ }
  }
  var brilloHecho = false;
  function brillo() {
    if (brilloHecho || quieto()) return;
    brilloHecho = true;
    el.cta.classList.add('is-brillo');
    setTimeout(function () { el.cta.classList.remove('is-brillo'); }, 900);
  }
  function todo(o) {
    o = o || {};
    if (o.tonos !== false) pintarTonos();
    if (o.telas !== false) pintarTelas();
    pintarPropuesta(o.animarProp);
    pintarEtiqueta();
    pintarCTA();
    if (escena) escena.aplicar(look(), { punto: o.punto, inst: o.inst });
    sincronizarURL();
  }

  // ---------- acciones ----------
  function elegirGrupo(id, o) {
    var g = grupo(id); if (!g) return;
    S.grupo = g; S.estilo = null; S.avisoAgotada = '';
    var lista = telasDe(g.id);
    S.tela = lista[0] || parecidas(g)[0] || null;
    todo(o);
  }
  var puntoToque = null;
  root.addEventListener('pointerdown', function (e) { puntoToque = { x: e.clientX, y: e.clientY, t: Date.now() }; }, { passive: true });
  root.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('button,[data-scc-reintentar]') : null;
    if (!b || !root.contains(b)) return;
    var punto = puntoToque && Date.now() - puntoToque.t < 1500 ? puntoToque : null;
    if (b.hasAttribute('data-scc-reintentar')) { cargar(); return; }
    if (b.hasAttribute('data-piso')) {
      var pid = b.getAttribute('data-piso');
      if (S.pisoElegido && S.piso === pid) { S.pisoElegido = false; S.piso = 'clara'; } else { S.piso = pid; S.pisoElegido = true; }
      pintarPisos(); todo({ telas: false });
      if (S.pisoElegido) visibleSobreBarra($('[data-scc-piso-tip]'));
      return;
    }
    if (b.hasAttribute('data-grupo')) { elegirGrupo(b.getAttribute('data-grupo'), { punto: punto }); return; }
    if (b.hasAttribute('data-estilo')) {
      var p = D.paletas.filter(function (x) { return x.id === b.getAttribute('data-estilo'); })[0];
      if (!p || !grupo(p.grupo)) return;
      S.grupo = grupo(p.grupo); S.avisoAgotada = '';
      S.tela = telasDe(S.grupo.id)[0] || parecidas(S.grupo)[0] || null;
      S.estilo = p;
      pintarEstilosEstado();
      todo({ animarProp: true, punto: punto });
      brillo();
      return;
    }
    if (b.hasAttribute('data-tela')) {
      var id = b.getAttribute('data-tela');
      var t = D.telas.filter(function (x) { return x.id === id; })[0];
      if (!t) return;
      if (t.grupo !== S.grupo.id) S.grupo = grupo(t.grupo);
      S.tela = t; S.avisoAgotada = '';
      Array.prototype.forEach.call(root.querySelectorAll('[data-tela]'), function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      todo({ telas: false, punto: punto });
      return;
    }
    if (b.hasAttribute('data-prop')) {
      S.prop = b.getAttribute('data-prop'); S.estilo = null;
      pintarEstilosEstado();
      todo({ telas: false, tonos: false, animarProp: true });
      brillo();
    }
  });
  // En celular la barra fija tapa la franja de abajo: si lo recién mostrado quedó debajo, se sube lo justo.
  function visibleSobreBarra(n) {
    if (!n || getComputedStyle(el.barra).position !== 'fixed') return;
    var r = n.getBoundingClientRect(), tope = el.barra.getBoundingClientRect().top - 12;
    if (r.bottom > tope) window.scrollBy({ top: r.bottom - tope, behavior: quieto() ? 'auto' : 'smooth' });
  }
  function pintarEstilosEstado() {
    Array.prototype.forEach.call(root.querySelectorAll('[data-estilo]'), function (x) { x.setAttribute('aria-pressed', String(!!S.estilo && x.getAttribute('data-estilo') === S.estilo.id)); });
  }
  el.cta.addEventListener('click', function () {
    if (!D) return;
    pintarCTA();
    try { if (window.gtag) window.gtag('event', 'contact', { method: 'combina_colores', propuesta: S.estilo ? 'estilo-' + S.estilo.id : S.prop, tono: S.grupo.id }); } catch (e) {}
  });

  // ---------- carga ----------
  function estado(tipo) {
    root.setAttribute('data-estado', tipo);
    el.estado.hidden = tipo === 'listo';
    el.pasos.hidden = tipo !== 'listo';
    if (tipo === 'cargando') {
      el.estado.innerHTML = '<div class="scc-esq" aria-label="Cargando las telas">' + new Array(7).join('<span></span>') + '</div>';
    } else if (tipo === 'error') {
      el.estado.innerHTML = '<div class="scc-error" role="alert"><p>Algo no salió bien. Intenta de nuevo en un momento.</p>'
        + '<button type="button" class="scc-btn2" data-scc-reintentar>Intentar de nuevo</button></div>';
    }
  }
  function iniciarEstado() {
    var tPar = Q.get('tela'), gPar = Q.get('tono'), pPar = Q.get('p'), ePar = Q.get('estilo'), piPar = Q.get('piso');
    if (piPar && PISOS.some(function (x) { return x.id === piPar; })) { S.piso = piPar; S.pisoElegido = true; }
    if (pPar && PROPS.some(function (x) { return x.id === pPar; })) S.prop = pPar;
    var t = null;
    if (tPar) {
      var n = norm(tPar);
      t = D.telas.filter(function (x) { return x.id === n || (x.crm && x.crm === tPar); })[0] || null;
      if (!t) {
        var ag = D.todas.filter(function (x) { return x.id === n || (x.crm && x.crm === tPar); })[0];
        if (ag && grupo(ag.grupo)) {
          gPar = ag.grupo;
          S.avisoAgotada = 'La tela ' + ag.nombre + ' está agotada en este momento; estas son las disponibles del mismo tono.';
        }
      }
    }
    var g = (t && grupo(t.grupo)) || grupo(gPar) || grupo('beige') || D.grupos[0];
    S.grupo = g;
    S.tela = t || telasDe(g.id)[0] || parecidas(g)[0] || null;
    if (ePar) { var p = D.paletas.filter(function (x) { return x.id === ePar; })[0]; if (p && p.grupo === g.id) S.estilo = p; }
  }
  var cargando = false;
  function cargar() {
    if (cargando) return;
    cargando = true;
    estado('cargando');
    var url = root.getAttribute('data-carta-url') || root.getAttribute('data-carta-prueba');
    var ctl = window.AbortController ? new AbortController() : null;
    var reloj = setTimeout(function () { if (ctl) ctl.abort(); }, 12000);
    var espera = PRUEBA === 'lento' ? 2500 : 0;
    new Promise(function (r) { setTimeout(r, espera); })
      .then(function () {
        if (PRUEBA === 'error') throw new Error('prueba de error');
        return fetch(url, { credentials: 'omit', signal: ctl ? ctl.signal : undefined });
      })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (d) {
        clearTimeout(reloj);
        D = normalizar(d);
        if (!D.grupos.length) throw new Error('carta vacía');
        iniciarEstado();
        estado('listo');
        if (!escena) escena = Escena(el.escena);
        pintarPisos();
        pintarEstilos();
        todo({ inst: true });
        root.classList.add('is-listo');
        cargando = false;
      })
      .catch(function (err) {
        clearTimeout(reloj);
        cargando = false;
        if (window.console) console.warn('[combina-colores]', err && err.message);
        estado('error');
      });
  }

  // Escena «vacía» mientras carga: la sala sin vestir (no un spinner).
  escena = Escena(el.escena);
  escena.aplicar({ clave: 'v', tela: { img: null, hex: '#E3DED5' }, tinte: '#F3F0EA', piso: 'clara', cojines: [], poltrona: '#E6E0D5', tapete: '#E7E1D6', madera: { nombre: '', hex: '#E2DCD2', tipo: 'pintura' } }, { inst: true });
  Array.prototype.forEach.call(root.querySelectorAll('[data-scc-aviso]'), function (n) { n.textContent = AVISO; });
  // En celular la barra fija no puede tapar el final de la página (ni el selector de piso): se reserva su alto.
  function reservar() {
    var fija = getComputedStyle(el.barra).position === 'fixed';
    root.style.setProperty('--scc-reserva', fija ? (el.barra.offsetHeight + 16) + 'px' : '0px');
  }
  reservar();
  if (window.ResizeObserver) new ResizeObserver(reservar).observe(el.barra);
  // Mientras carga (o si falla) el botón igual sirve: abre WhatsApp con un mensaje general.
  var generico = 'Hola, quiero asesoría para elegir los colores de mi mueble. [Ref CC]';
  el.cta.href = 'https://wa.me/' + WA + '?text=' + encodeURIComponent(typeof window.sairaWaConOrigen === 'function' ? window.sairaWaConOrigen(generico) : generico);
  pintarPisos();
  window.addEventListener('resize', reservar);
  cargar();
})();
